import { useShop } from "hooks/firestore/simple/useShop"

export function useOfferingId() {
  const currentShop = useShop()
  const offeringId = currentShop?.offering?.offeringId
  return offeringId
}
